import { AITeaserSection } from '../sections/AITeaserSection';
import { AudienceTriageSection } from '../sections/AudienceTriageSection';
import { ProofStripSection } from '../sections/ProofStripSection';
import { StahuljakStorySection } from '../sections/StahuljakStorySection';
import { ThreePillarsSection } from '../sections/ThreePillarsSection';
import { HeroSection } from '../sections/HeroSection';

import { useDocumentTitle } from '@/hooks/useDocumentTitle';

import styles from './HomePage.module.css';

export function HomePage() {
  useDocumentTitle();

  return (
    <div className={styles.page}>
      <HeroSection />
      <ThreePillarsSection />
      <StahuljakStorySection />
      <AudienceTriageSection />
      <ProofStripSection />
      <AITeaserSection />
    </div>
  );
}
